import queryString from 'query-string'
import { PROFILE } from "../api/profile";
const state = {
    profiles: {}

};

const mutations = {
    setProfile: (states, payload) => {
        states.profiles = payload;
    },
};
const actions = {
    getProfile: async ({
        commit
    }) => {
        // try {
            const resp = await PROFILE()
            const datas = resp.data.data
            commit("setProfile", datas);
        // } catch (err) {
        //     let resp = err.response;
        //     console.log(err);
        //     if (resp.data.httpCode === 500) {
        //         commit("setProfile", {
        //             setProfile: {},
        //         });
        //     }
        // }
    },

};

const getters = {
    profileData: (states) => states.profiles

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};